import { IGetUsecasesResponse } from '@shared/models';
import useAxios, { UseAxiosResult } from 'axios-hooks';

export default function useTcrUsecases(brandId: string): UseAxiosResult<IGetUsecasesResponse> {
  const data = useAxios<IGetUsecasesResponse>({
    url: `tcr-enums/use-cases?brandId=${brandId}`,
    method: 'GET'
  });
  return data;
}
